import { render } from "./FooterLanding.vue?vue&type=template&id=515bd7cf"
import script from "./FooterLanding.vue?vue&type=script&lang=js"
export * from "./FooterLanding.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/frontend-dilatih/frontend-dilatih/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__